export * from './cnpj'
export * from './cpf'
export * from './email'
export * from './idade'
export * from './ip'